var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedeem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 16H5.33329V26.6667C5.33329 27.3739 5.61424 28.0522 6.11434 28.5523C6.61444 29.0524 7.29272 29.3333 7.99996 29.3333H14.6666V16H6.66663ZM24 16H17.3333V29.3333H24C24.7072 29.3333 25.3855 29.0524 25.8856 28.5523C26.3857 28.0522 26.6666 27.3739 26.6666 26.6667V16H24ZM25.0546 9.33332C25.2502 8.68503 25.3442 8.01038 25.3333 7.33332C25.3333 4.75999 23.24 2.66666 20.6666 2.66666C18.504 2.66666 17.06 4.64266 16.128 6.77999C15.2093 4.75999 13.692 2.66666 11.3333 2.66666C8.75996 2.66666 6.66663 4.75999 6.66663 7.33332C6.66663 8.12799 6.77196 8.78532 6.94529 9.33332H2.66663V14.6667H14.6666V12H17.3333V14.6667H29.3333V9.33332H25.0546ZM9.33329 7.33332C9.33329 6.23066 10.2306 5.33332 11.3333 5.33332C12.5173 5.33332 13.6186 7.36666 14.264 9.33332H10.6666C10.168 9.33332 9.33329 9.33332 9.33329 7.33332ZM20.6666 5.33332C21.7693 5.33332 22.6666 6.23066 22.6666 7.33332C22.6666 9.33332 21.832 9.33332 21.3333 9.33332H18.0306C18.7106 7.23199 19.6986 5.33332 20.6666 5.33332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeem);
export default __webpack_public_path__ + "static/media/redeem.4b237ea521ea696ec1f45463ae9879df.svg";
export { ForwardRef as ReactComponent };